import { memo } from "react";
import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useBuilderStore } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import type { StyledFrameProps as Props } from "@circle-react-shared/StyledFrame";
import { StyledFrame as Frame } from "@circle-react-shared/StyledFrame";
import { IFRAME_DATA_TEST_ID, IFRAME_ID } from "./constants";

export interface StyledFrameProps extends Props {
  children: ReactNode;
}

/** An iframe that copies all the styles of the parent page */
export const StyledFrame = memo(
  ({ children, className, ...rest }: StyledFrameProps) => {
    const isDragging = useBuilderStore(state => state.isDragging);

    return (
      <Frame
        id={IFRAME_ID}
        data-testid={IFRAME_DATA_TEST_ID}
        className={classNames(className, {
          // https://github.com/clauderic/dnd-kit/issues/1374
          ["pointer-events-none"]: isDragging,
        })}
        {...rest}
      >
        {children}
      </Frame>
    );
  },
);

StyledFrame.displayName = "BuilderUIStyledFrame";
